<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/home" @click="updateListCategory('listCategoryHome')">Home</b-breadcrumb-item>
      <b-breadcrumb-item to="/collaborativeList" @click="updateListCategory('collaborativeList')">Collaborative List</b-breadcrumb-item>
      <b-breadcrumb-item v-if="toDoListId" :to="{ name: 'Collaborative Task List', params: { collaborativeListId: toDoListId }}" @click="updateListCategory('collaborativeTaskList')">
        {{toDoListDetails.toDoListName}}</b-breadcrumb-item>
      <b-breadcrumb-item href="#viewCollaborators" active>View Collaborators</b-breadcrumb-item>
    </b-breadcrumb>
    <h1 class="template-name">View Collaborators</h1>
    <p>Take a look at the list collaborators.</p>
    <hr>
    <b-tabs content-class="mt-3" active-nav-item-class="font-weight-bold">
      <b-tab title="Administrator">
        <div class="collaborator-container">
          <div v-if="showPlaceholderImageAdministrator && !hideWhenInitialLoadAdministrator" class="no-collaborator-container">
            <b-img class="no-collaborator-picture" :src="require('../../assets/no_collaborator.png')"
                   alt="No collaborator picture"></b-img>
            <h2>No Administrator Collaborator</h2>
            <p>The to-do list administrator will be shown here</p>
          </div>
          <collaborator-list-cell  v-for="administratorCollaborator in collaborativeListAdministrator" :key="administratorCollaborator.id"
                                   :user-details="administratorCollaborator" @click.native="navigateToCollaboratorDetails(administratorCollaborator)"></collaborator-list-cell>
        </div>
      </b-tab>
      <b-tab title="Member">
        <div class="collaborator-container">
          <div v-if="showPlaceholderImageMember && !hideWhenInitialLoadMember" class="no-collaborator-container">
            <b-img class="no-collaborator-picture" :src="require('../../assets/no_collaborator.png')"
                   alt="No collaborator picture"></b-img>
            <h2>No Member Collaborator</h2>
            <p>The to-do list member will be shown here</p>
          </div>
          <collaborator-list-cell v-for="memberCollaborator in collaborativeListMember" :key="memberCollaborator.id"
                                  :user-details="memberCollaborator" @click.native="navigateToCollaboratorDetails(memberCollaborator)"></collaborator-list-cell>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  import CollaboratorListCell from "../table_cells/collaborator_cell/CollaboratorListCell"
  import {mapActions, mapGetters} from "vuex";
  import router from "../../router";
  import {db} from "../../main";

  export default {
    name: "ViewCollaborators.vue",
    components: {
      collaboratorListCell: CollaboratorListCell
    },
    data() {
      return {
        showPlaceholderImageAdministrator: null,
        showPlaceholderImageMember: null,
        hideWhenInitialLoadAdministrator: true,
        hideWhenInitialLoadMember: true,
        toDoListId: null,
        toDoListDetails: {},
        collaborativeListAdministrator: [],
        collaborativeListMember: []
      }
    },
    methods: {
      ...mapActions([
        "updateListCategory"
      ]),
      getCollaborativeListCollaborator() {
        this.$bind(
          'collaborativeListAdministrator',
          db
            .collectionGroup('user_collaborative_to_do_list_participation')
            .where('collaborativeToDoListId', '==', this.toDoListId)
            .where('collaborativeToDoListRole', '==', 'Administrator')
            .orderBy('collaboratorName', 'asc')
        ).then(() => {
          if (this.collaborativeListAdministrator.length === 0) {
            this.showPlaceholderImageAdministrator = true
          }
          this.hideWhenInitialLoadAdministrator = false
        })

        this.$bind(
          'collaborativeListMember',
          db
            .collectionGroup('user_collaborative_to_do_list_participation')
            .where('collaborativeToDoListId', '==', this.toDoListId)
            .where('collaborativeToDoListRole', '==', 'Member')
            .orderBy('collaboratorName', 'asc')
        ).then(() => {
          if (this.collaborativeListMember.length === 0) {
            this.showPlaceholderImageMember = true
          }
          this.hideWhenInitialLoadMember = false
        })
      },
      navigateToCollaboratorDetails(collaborator) {
        this.$store.dispatch('updateListCategory', 'collaboratorDetails')
        router.push({ name: 'Collaborator Details', params: { collaborativeListId: this.toDoListId, collaboratorId: collaborator.collaboratorId}})
      }
    },
    watch: {
      collaborativeListAdministrator(newProperties, oldProperties) {
        this.showPlaceholderImageAdministrator = this.collaborativeListAdministrator.length === 0
      },
      collaborativeListMember(newProperties, oldProperties) {
        this.showPlaceholderImageMember = this.collaborativeListMember.length === 0
      },
    },
    mounted() {
      this.toDoListId = this.$route.params.collaborativeListId

      // retrieve the collaborator role
      db.collectionGroup('user_collaborative_to_do_list_participation')
        .where('collaborativeToDoListId', '==', this.toDoListId)
        .where('collaboratorId', '==', this.$store.getters.user.data.id)
        .get()
        .then(querySnapshot => {
          const userCollaborativeToDoListParticipatedObject = querySnapshot.docs.map(doc => doc.data())

          this.$store.dispatch('setIsCollaborativeListAdministrator', userCollaborativeToDoListParticipatedObject[0].collaborativeToDoListRole === 'Administrator')
        })

      db.collection('collaborative_to_do_lists')
        .doc(this.toDoListId)
        .onSnapshot(doc => {
          this.toDoListDetails = doc.data()
        })

      this.getCollaborativeListCollaborator()
    }
  }
</script>

<style scoped>
  .no-collaborator-container {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .no-collaborator-picture {
    width: 375px;
    margin-bottom: 1em;
  }

  .template-name {
    font-size: 2em;
    margin-bottom: 0.5em;
  }

  .collaborator-container {
    height: 63vh;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
  }
</style>
